import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Qrcode = ({ content }) => {
    return content?.length > 0 ? (
        <div className={styles.qrcode}>
            {content.map((item, index) => {
                return (
                    <div key={index} className={styles.qrcodeItem}>
                        <img className={styles.qrcodePic} src={item.imageUrl} />
                        <div className={styles.qrcodeText}>{item.imageTitle}</div>
                    </div>
                );
            })}
        </div>
    ) : null;
};

Qrcode.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Qrcode);
